import Spline from "@/lib/spline"
import { lerp } from "@/core/utils/math"
import { vec2 } from "gl-matrix"

export const toneCurvePoints: vec2[] = [
	[0, 0],
	[2.5, 1.25],
	[10, 12],
	[34, 72],
	[83, 157],
	[142, 216],
	[255, 255],
]

export function getCurveLUT(points: number[] | Float32Array, width = 256) {
	const len = points.length / 2
	const xs = new Array(len)
	const ys = new Array(len)

	for (let i = 0; i < points.length; i += 2) {
		const j = i / 2
		xs[j] = points[i]
		ys[j] = points[i + 1]
	}

	const spline = new Spline(xs, ys)

	const curve = new Float32Array(width)

	for (let i = 0; i < curve.length; i++) {
		curve[i] = spline.at(i / (curve.length - 1))
	}

	return curve
}

export function getToneCurve() {
	const points = toneCurvePoints.map(normalizePoint)

	return getCurve(points, 1025)

	// return getCurveLUT(toneCurvePoints, 1025)

	// const toneCurve = info.profile_tone_curve.length
	//   ? info.profile_tone_curve
	//   : defaultToneCurve
}

export function normalizePoint(point: vec2): vec2 {
	return [point[0] / 255, point[1] / 255]
}

function intensifyPoint(point: vec2, intensity: number): vec2 {
	return [point[0], lerp(intensity, point[0], point[1])]
}

export function getContrastCurve(contrast: number, width = 1025) {
	let points: vec2[] = []
	if (contrast < 0) {
		points = [
			[0, 0],
			[8, 21],
			[16, 34],
			[32, 54],
			[64, 88],
			[96, 115],
			[128, 135],
			[160, 152],
			[192, 174],
			[224, 206],
			[240, 228],
			[255, 255],
		]
	} else {
		points = [
			[0, 0],
			[32, 8],
			[64, 35],
			[96, 71],
			[128, 117],
			[160, 171],
			[192, 212],
			[224, 241],
			[255, 255],
		]
	}

	points = points.map((p) => normalizePoint(intensifyPoint(p, Math.abs(contrast))))

	return getCurve(points, width)
}

export function getAdobeColorProfileCurve() {
	// Adobe Color
	let points: vec2[] = [
		[0, 0],
		[22, 16],
		[40, 35],
		[127, 127],
		[224, 230],
		[240, 246],
		[255, 255],
	]

	points = points.map(normalizePoint)

	return getCurve(points, 256)
}

export function getCurve(points: vec2[], width: number) {
	const len = points.length
	const xs = new Array(len)
	const ys = new Array(len)

	points.forEach((point, i) => {
		xs[i] = point[0]
		ys[i] = point[1]
	})

	const spline = new Spline(xs, ys)

	const curve = new Float32Array(width)

	for (let i = 0; i < width; i++) {
		curve[i] = spline.at(i / (width - 1))
	}

	return curve
}
